// ANGULAR DEPENDENCY
import { Injectable } from '@angular/core';

// NGRX AND RXJS
import { Store } from '@ngrx/store';

// GLOBAL ACTIONS, SELECTORS AND STATES
import { State } from '../../root-state';
import * as actions from './store/actions';
import * as selectors from './store/selectors';

// COMMON INTERFACES
import { ApiPayload } from '../../../models/common/api/api-payload.interface';
@Injectable()
export class PermissionStoreService {

  constructor(
    protected store: Store<State>,
  ) {
  }

  /************** Dispatchers ************** */

  // -------------------------------
  //  Dispatch Permission common method everytime
  // -------------------------------
  dispatchPermissionCommon(payload: ApiPayload) {
    this.store.dispatch(new actions.PermissionCommonAction(payload));
  }

}
